import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledContent = styled(StyledCenteredContent)`
  gap: 2.4rem;
  background: ${secondaryColors.offBlack};
  padding: 4.6rem 1.8rem 3rem;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 4.6rem;
  }

  > * {
    z-index: 2;
  }
`;

export const StyledHeading = styled.h2`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 2.4rem;
  margin-bottom: 1.6rem;
  text-align: center;

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 3.2rem;
    sup {
      font-size: 2.4rem;
    }
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0.6rem;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  }
`;

export const StyledText = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
`;

const Gradient = styled.div`
  background: radial-gradient(50% 50% at 50% 50%, rgba(62, 71, 90, 1) 0%, rgba(21, 28, 43, 0) 100%);
  width: 87rem;
  height: 40rem;
  z-index: 1;
`;

export const TopGradient = styled(Gradient)`
  position: absolute;
  left: -51rem;
  top: -9.4rem;
`;

export const BottomGradient = styled(Gradient)`
  position: absolute;
  bottom: -17rem;
`;
